import App from './App';
import './assets/fonts/inter.css';
import './global.css';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')!).render(<App />);
